import { atom } from 'jotai'
import { urls } from '../constants'
import { GetRequest, PostRequest } from '../api'
import { alertAtom, globalLoaderAtom } from './globalStateAtoms'

export const getCompaniesListAllForMTPLMasterData = atom([])
export const fetchCompaniesListAllAtoms = atom(null, async (get, set, data) => {
  try {
    set(globalLoaderAtom, true)
    const res = await PostRequest(urls.getCompaniesListAll, data)
    if (res.status === 'Success') {
      set(getCompaniesListAllForMTPLMasterData, res.Data)
    } else {
      set(getCompaniesListAllForMTPLMasterData, [])
      set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data from server' })
    }
  } catch (error) {
    console.error(error)
    set(getCompaniesListAllForMTPLMasterData, [])
  } finally {
    set(globalLoaderAtom, false)
  }
})
export const getCargoSettingData = atom([])
export const getCargoMpesaSettingData = atom([])
export const fetchCargoSettingAtoms = atom(null, async (get, set, data) => {
  try {
    set(globalLoaderAtom, true)
    const res = await PostRequest(urls.getCargoSetting, data)
    if (res.status === 'Success') {
      set(getCargoSettingData, res.Data[0])
      set(getCargoMpesaSettingData, res?.Data2?.Table || res?.Data2 || [])
    } else {
      set(getCargoSettingData, [])
      set(getCargoMpesaSettingData, [])
      set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data from server' })
    }
  } catch (error) {
    console.error(error)
    set(getCargoSettingData, [])
    set(getCargoMpesaSettingData, [])
  } finally {
    set(globalLoaderAtom, false)
  }
})

export const userListForLuggageSettingUpdateAtom = atom([])
export const fetchUserListForLuggageSettingUpdateAtom = atom(null, async (get, set) => {
  try {
    const res = await GetRequest(urls.userListForLuggageSettingUpdate, {})
    if (res.status === 'Success') {
      set(userListForLuggageSettingUpdateAtom, res?.Data?.Table || res?.Data?.Table1 || res?.Data || [])
    } else {
      set(userListForLuggageSettingUpdateAtom, [])
      set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data from server' })
    }
  } catch (error) {
    console.error(error)
    set(userListForLuggageSettingUpdateAtom, [])
  } finally {
  }
})
